import { createBlock, mergeBlock, t } from "@easy-email-pro-core/utils";

import { ElementCategory, StandardType } from "@easy-email-pro-core/constants";
import {
  ElementDefinition,
  StandardTableElement,
} from "@easy-email-pro-core/typings";
import React from "react";
import { Table } from "@easy-email-pro-core/components/Elements";
import { Table as SourceElement } from "../../basic/Table";

const defaultData: ElementDefinition<StandardTableElement>["defaultData"] =
  mergeBlock(SourceElement.defaultData, {
    attributes: {},
    data: {
      code: "",
    },
  });

export const StandardTable = createBlock<StandardTableElement>({
  get name() {
    return t("Table");
  },
  void: true,
  defaultData,
  type: StandardType.STANDARD_TABLE,
  create: (payload) => {
    const defaultData: StandardTableElement = {
      type: StandardType.STANDARD_TABLE,
      data: {
        code: "",
      },
      attributes: {},
      children: [],
    };
    return mergeBlock(defaultData, payload);
  },
  category: ElementCategory.TABLE,
  render(params) {
    const { node, children } = params;
    return (
      <Table idx={params.idx} {...node.attributes} data={node.data}>
        {children || node.data.code}
      </Table>
    );
  },
});
